<div style="background-color: #2f3333;">
  <div class="header">
    <h1 style="color: #fff" mat-dialog-title>Sugestões</h1>
    <mat-icon style="color: #fff" mat-dialog-close="cancel">close</mat-icon>
  </div>
  <div *ngIf="isLoadingSugestao" class="d-flex justify-content-center">
    <mat-spinner
      style="padding: 10px"
      color="primary"
      mode="indeterminate"
    ></mat-spinner>
  </div>
  <div *ngIf="!isLoadingSugestao" mat-dialog-content>
    <form [formGroup]="formSugestao">
      <h3 class="title-form">Assunto: (mín 5 caracteres)</h3>
      <mat-form-field appearance="outline">
        <input
          matInput
          minlength="5"
          formControlName="assunto"
          placeholder="Digite aqui o assunto..."
          required
        />
      </mat-form-field>
      <br />
      <h3 class="title-form">Sugestão: (mín 20 caracteres)</h3>
      <mat-form-field appearance="outline">
        <textarea
          matInput
          cdkTextareaAutosize
          #autosize="cdkTextareaAutosize"
          formControlName="descricao"
          required
          minlength="20"
          placeholder="Digite aqui sua sugestão..."
          cdkAutosizeMinRows="5"
          cdkAutosizeMaxRows="5"
        ></textarea>
      </mat-form-field>
    </form>
    <div class="footer-sugestao">
      <button
        [disabled]="formSugestao.invalid || disableButton"
        mat-flat-button
        (click)="enviarSugestao()"
        color="primary"
        type="submit"
      >
        Enviar
      </button>
    </div>
  </div>
</div>
